































































































































































import mixins from 'vue-typed-mixins'

import I18N from '@/components/I18N.ts'
import SearchInput from '@/components/SearchInput.vue'
import Root from '@/components/Root.vue'

import axios from 'axios'

function query2bool (val: any, def: boolean = true): boolean {
  if (val !== undefined) {
    return val === '1' || val === 'true'
  } else {
    return def
  }
}

function bool2query (val: boolean): string {
  return val ? '1' : '0'
}

interface Data {
  types: string[] // for dropdown
  consonants: string[] // for dropdown
  search: { // linked to inputs
    s: string // free input query
    c1: string // consonant drop-downs
    c2: string
    c3: string
    c4: string
    t: string // type
  },
  term: string | null // actual term computed and returned from API
  page: number // last page retrieved
  working: boolean
  results: Result[]
  resultCount: number // as reported by server, only equal to resuls.length when all results loaded
}

interface Result {
  root: Root
  lexemes: Lexeme[]
}

function is (x: any): boolean {
  return x !== undefined && x !== null && x !== ''
}

export default mixins(I18N).extend({
  components: {
    SearchInput,
    Root
  },
  data (): Data {
    return {
      types: ['strong', 'geminated', 'weak-initial', 'weak-medial', 'weak-final', 'irregular'],
      consonants: ['b', 'ċ', 'd', 'f', 'ġ', 'g', 'għ', 'h', 'ħ', 'j', 'k', 'l', 'm', 'n', 'p', 'q', 'r', 's', 't', 'v', 'w', 'x', 'ż', 'z', '[jw]', '\''],
      search: {
        // These default values are overwritten by watch below
        s: '',
        c1: '',
        c2: '',
        c3: '',
        c4: '',
        t: ''
      },
      term: null,
      page: 0,
      working: false,
      results: [],
      resultCount: 0
    }
  },
  watch: {
    // Populate local search object whenever URL changes
    '$route.query': {
      handler (): void {
        this.search = {
          s: this.$route.query.s as string || '',
          c1: this.$route.query.c1 as string || '',
          c2: this.$route.query.c2 as string || '',
          c3: this.$route.query.c3 as string || '',
          c4: this.$route.query.c4 as string || '',
          t: this.$route.query.t as string || ''
        }
        if (this.isSearching) {
          this.results = []
          this.resultCount = 0
          this.page = 0
          this.loadResults()
          this.term = null
        } else {
          this.$store.dispatch('setTitle', { key: 'Root search' })
        }
      },
      immediate: true
    },
    term: {
      handler (): void {
        if (this.term !== null) {
          this.$store.dispatch('setTitle', { key: 'title.search', replacements: [this.term] })
        }
      },
      immediate: true
    }
  },
  computed: {
    isSearching (): boolean {
      return is(this.$route.query.s) || is(this.$route.query.c1) || is(this.$route.query.c2) || is(this.$route.query.c3) || is(this.$route.query.c4) || is(this.$route.query.t)
    },
    moreResults (): boolean {
      return this.results.length < this.resultCount
    }
  },
  methods: {
    // the form is submitted
    submitSearch (): void {
      this.$router.push({
        query: {
          s: this.search.s,
          c1: this.search.c1,
          c2: this.search.c2,
          c3: this.search.c3,
          c4: this.search.c4,
          t: this.search.t
        }
      })
    },
    // get results
    loadResults (): void {
      this.working = true
      axios.get(`${process.env.VUE_APP_API_URL}/roots/search`, {
        params: {
          s: this.search.s,
          c1: this.search.c1,
          c2: this.search.c2,
          c3: this.search.c3,
          c4: this.search.c4,
          t: this.search.t,
          page: ++this.page
        } })
        .then(response => {
          response.data.results.forEach((r: Result) => {
            this.results.push(r)
          })
          this.term = response.data.query.term || this.search.t
          this.resultCount = response.data.query.result_count
        })
        .catch(error => {
          this.$store.dispatch('addError', error)
        })
        .then(() => {
          this.working = false
        })
    },
    lexemesByForm (item: Result, form: number): Lexeme[] {
      return item.lexemes.filter((l) => l.derived_form === form)
    }
  },
  mounted (): void {
    // https://renatello.com/check-if-a-user-has-scrolled-to-the-bottom-in-vue-js/
    window.onscroll = () => {
      let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
      if (bottomOfWindow && !this.working && this.moreResults) {
        this.loadResults()
      }
    }
  }
})
